export const ds_ImageAndTextAccordionBlock_Entry = `
    fragment ds_ImageAndTextAccordionBlock_Entry on ds_ImageAndTextAccordionBlock_Entry {
        id
        canonicalUid

        imageAndTextAccordion_ColorTheme
        imageAndTextAccordion_ColorPalette
        imageAndTextAccordion_TopSpacing
        imageAndTextAccordion_ContainerWidth
        imageAndTextAccordion_FullWidthBackground

        imageAndTextAccordion_Subheading
        imageAndTextAccordion_Heading
        imageAndTextAccordion_BodyText
        imageAndTextAccordion_AccordionStyle
        imageAndTextAccordion_ImagePlacement
        imageAndTextAccordion_HeadingAndTextAlignment

        imageAndTextAccordion_DefaultImage {
            url @transform (width: 550, height: 550)
            alt
            focalPoint
        }

        imageAndTextAccordion_BackgroundElement {
            canonicalUid
            id
        }

        imageAndTextAccordion_AccordionItems {
            ... on ds_ImageAndTextAccordionItem_Entry {
                id
                imageAndTextAccordionItem_Heading
                imageAndTextAccordionItem_BodyText
                imageAndTextAccordionItem_Image {
                    url @transform (width: 550, height: 550)
                    alt
                    focalPoint
                }
                imageAndTextAccordionItem_Icon {
                    type
                    name
                    set
                }
                imageAndTextAccordionItem_Button {
                    text
                    target
                    title
                    url
                    ariaLabel
                    ... on imageAndTextAccordionItem_Button_Custom_LinkType {
                        buttonStyle
                    }
                    ... on imageAndTextAccordionItem_Button_Entry_LinkType {
                        buttonStyle
                    }
                    ... on imageAndTextAccordionItem_Button_Url_LinkType {
                        buttonStyle
                    }
                    ... on imageAndTextAccordionItem_Button_Phone_LinkType {
                        buttonStyle
                    }
                    ... on imageAndTextAccordionItem_Button_Email_LinkType {
                        buttonStyle
                    }
                }
            }
        }
    }
`
